import officeData from './office/officeData'
import libraryData from './library/libraryData'
import laboratoryData from './laboratory/laboratoryData'
import fourJokersData from './fourJokers/fourJokersData'
import lastStandData from './lastStand/lastStandData'
import machineData from '../theMachine/machineData'

const clueData = {
    office: officeData,
    library: libraryData,
    laboratory: laboratoryData,
    fourJokers: fourJokersData,
    lastStand: lastStandData,
    machine: machineData
} 

export default clueData